import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IAddress } from 'app/models/address/address';
import { Observable } from 'rxjs';
import { IAddressType } from 'app/models/address/address-type';

@Injectable({providedIn: 'root'})

export class AddressService {
  public api: string = environment.privateApi + 'Address/'
  private http = inject(HttpClient);

  getAddresses(entityId: number, entityType: string, includeArchived: boolean): Observable<IAddress[]>{
    return this.http.get<IAddress[]>(this.api + 'GetAddresses/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  getAddressTypes(includeArchived: boolean): Observable<IAddressType[]>{
    return this.http.get<IAddressType[]>(this.api + 'GetAddressTypes/' + includeArchived);
  }

  createAddress(address: IAddress, entityId: number, entityType: string): Observable<IAddress>{
    return this.http.post<IAddress>(this.api + 'CreateAddress/' + entityId + '/' + entityType, address);
  }

  updateAddress(address: IAddress): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateAddress', address);
  }

  archiveAddress(addressId: number, archived: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveAddress/' + addressId + '/' + archived, null);
  }
}
